import React, { useCallback, useEffect, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import styles from './NotificationsPanel.module.scss'

const propTypes = {}

// Dispatched by public/js/consent-manager.js as the Beamer SDK is loaded or torn down.
const BEAMER_LOADED_EVENT = 'augmentt:beamer-loaded'
const BEAMER_UNLOADED_EVENT = 'augmentt:beamer-unloaded'

function isBeamerLoaded() {
  return typeof window !== 'undefined' && Boolean(window.Beamer)
}

function NotificationsPanel() {
  const [beamerLoaded, setBeamerLoaded] = useState(isBeamerLoaded)

  const handleBeamerLoaded = useCallback(() => setBeamerLoaded(true), [])

  const handleBeamerUnloaded = useCallback(() => setBeamerLoaded(false), [])

  // Track Beamer load/unload (async after CookieYes consent changes).
  useEffect(() => {
    window.addEventListener(BEAMER_LOADED_EVENT, handleBeamerLoaded)
    window.addEventListener(BEAMER_UNLOADED_EVENT, handleBeamerUnloaded)

    return () => {
      window.removeEventListener(BEAMER_LOADED_EVENT, handleBeamerLoaded)
      window.removeEventListener(BEAMER_UNLOADED_EVENT, handleBeamerUnloaded)
    }
  }, [handleBeamerLoaded, handleBeamerUnloaded])

  return (
    <div className="header__topbar-item">
      <div className="header__topbar-wrapper">
        <span className="header__topbar-icon">
          <OverlayTrigger
            placement="bottom"
            show={beamerLoaded ? false : undefined}
            overlay={
              <Tooltip className={styles.tooltip}>
                <FormattedMessage id="BEAMER.ENABLE_COOKIES" />
              </Tooltip>
            }
          >
            <span className="icon-xl flaticon2-notification" id="notifications" />
          </OverlayTrigger>
        </span>
      </div>
    </div>
  )
}

NotificationsPanel.propTypes = propTypes
export default NotificationsPanel
